import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Uploader from "@/components/Uploader";

const field = "w-full border border-neutral-200 px-3 py-3 text-sm focus:border-neutral-900 outline-none";
const CATS = ["Vêtements", "Bijoux", "Décoration & Objets", "Cosmétiques & Beauté"];

export default function SellerApply() {
  const { user, ready, refreshUser } = useAuth();
  const nav = useNavigate();
  const [existing, setExisting] = useState(null);
  const [loading, setLoading] = useState(false);
  const [f, setF] = useState({
    brand_name: "", first_name: "", last_name: "", email: user?.email || "", universe: "",
    main_category: "Vêtements", categories: [], country: "France", city: "", website: "", socials: "", phone: "", sample_images: [],
  });

  useEffect(() => {
    if (ready && !user) nav("/connexion", { state: { from: "/devenir-createur" } });
    if (user) { setF((p) => ({ ...p, email: user.email })); api.get("/sellers/me").then(({ data }) => setExisting(data.seller)); }
  }, [user, ready, nav]);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await api.post("/sellers/apply", { ...f, categories: f.categories.length ? f.categories : [f.main_category] });
      toast.success("Candidature envoyée");
      await refreshUser();
      const { data } = await api.get("/sellers/me"); setExisting(data.seller);
    } catch (err) { toast.error(errMsg(err)); }
    setLoading(false);
  };

  if (existing && ["pending", "approved", "suspended"].includes(existing.status)) {
    const map = { pending: ["En attente de validation", "Votre candidature est en cours d'examen par notre comité."],
      approved: ["Candidature acceptée", "Bienvenue ! Accédez à votre espace créateur."],
      suspended: ["Compte suspendu", "Contactez l'administration pour plus d'informations."] };
    return (
      <div className="max-w-xl mx-auto px-4 py-24 text-center">
        <span className="over text-[0.62rem] text-[#D4AF37]">Statut de candidature</span>
        <h1 className="font-display text-4xl font-light mt-3">{map[existing.status][0]}</h1>
        <p className="text-neutral-500 mt-4">{map[existing.status][1]}</p>
        {existing.status === "approved" && <button onClick={() => nav("/espace-createur")} className="btn btn-dark mt-8">Mon espace créateur</button>}
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-14">
      <span className="over text-[0.62rem] text-[#D4AF37]">Rejoindre la sélection</span>
      <h1 className="font-display text-4xl lg:text-5xl font-light mt-3">Devenir créateur</h1>
      <p className="text-neutral-500 mt-3">Présentez votre univers. Chaque candidature est étudiée avec soin.</p>

      <form onSubmit={submit} className="mt-10 space-y-5">
        <div className="grid sm:grid-cols-2 gap-4">
          <input required placeholder="Prénom" value={f.first_name} onChange={(e) => setF({ ...f, first_name: e.target.value })} className={field} data-testid="apply-first" />
          <input required placeholder="Nom" value={f.last_name} onChange={(e) => setF({ ...f, last_name: e.target.value })} className={field} data-testid="apply-last" />
        </div>
        <input required placeholder="Nom de marque / créateur" value={f.brand_name} onChange={(e) => setF({ ...f, brand_name: e.target.value })} className={field} data-testid="apply-brand" />
        <input required type="email" placeholder="E-mail" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className={field} data-testid="apply-email" />
        <textarea required placeholder="Décrivez votre univers créatif…" value={f.universe} onChange={(e) => setF({ ...f, universe: e.target.value })} className={`${field} h-28`} data-testid="apply-universe" />
        <div>
          <label className="over text-[0.6rem] text-neutral-500">Catégorie principale</label>
          <div className="flex flex-wrap gap-2 mt-2">
            {CATS.map((c) => (
              <button type="button" key={c} onClick={() => setF({ ...f, main_category: c })} className={`over text-[0.6rem] px-3 py-2 border ${f.main_category === c ? "bg-[#0A0A0A] text-white border-[#0A0A0A]" : "border-neutral-200"}`}>{c}</button>
            ))}
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          <input placeholder="Pays" value={f.country} onChange={(e) => setF({ ...f, country: e.target.value })} className={field} />
          <input placeholder="Ville" value={f.city} onChange={(e) => setF({ ...f, city: e.target.value })} className={field} />
          <input placeholder="Site internet (optionnel)" value={f.website} onChange={(e) => setF({ ...f, website: e.target.value })} className={field} />
          <input placeholder="Réseaux sociaux (optionnel)" value={f.socials} onChange={(e) => setF({ ...f, socials: e.target.value })} className={field} />
          <input placeholder="Téléphone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} className={`${field} sm:col-span-2`} />
        </div>
        <div>
          <label className="over text-[0.6rem] text-neutral-500 block mb-2">Exemples de créations</label>
          <Uploader value={f.sample_images} onChange={(v) => setF({ ...f, sample_images: v })} hint="Ajoutez quelques visuels représentatifs de votre travail." />
        </div>
        <button disabled={loading} className="btn btn-magenta" data-testid="apply-submit">{loading ? "Envoi…" : "Envoyer ma candidature"}</button>
      </form>
    </div>
  );
}
